import React from 'react';
import {
  TableContainer,
  Table as MuiTable,
  Paper,
  TableBody,
  TableRow,
  TableCell,
  Typography,
  TableHead,
} from '@material-ui/core';
import LoadingPlaceholder from './components/LoadingPlaceholder';
import EmptyPlaceholder from './components/EmptyPlaceholder';

import { TableProps } from './types';
import { useStyles } from './styles';

export default function Table<T>(props: TableProps<T>) {
  const { data, columns, emptyPlaceholder, loading } = props;
  const classes = useStyles();

  return (
    <Paper>
      <TableContainer className={classes.tableContainer}>
        <MuiTable>
          <TableHead>
            <TableRow>
              {columns.map((column) => (
                <TableCell key={column.title} align={column.align}>
                  <Typography variant="subtitle2" className={classes.headTitle}>
                    {column.title}
                  </Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((item, index) => (
              <TableRow key={item.id} hover tabIndex={-1}>
                {columns.map((column) => (
                  <TableCell component="th" scope="row" key={column.title} align={column.align}>
                    {typeof column.cell === 'function'
                      ? column.cell(item, index)
                      : item[column.cell] || '-'}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </MuiTable>
      </TableContainer>
      {loading && <LoadingPlaceholder />}
      {data.length === 0 && !loading && <EmptyPlaceholder placeholder={emptyPlaceholder} />}
    </Paper>
  );
}
